import { Box, styled } from '@mui/material';

export const ONLINE_CART_TOKENS = {
  fontFamily: '"Barlow", Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  background: '#F8F9FC',
  surface: '#FFFFFF',
  textPrimary: '#030B3D',
  textDisplay: '#00023e',
  textSupport: '#5c6370',
  textMutedSoft: '#667085',
  textHeadingSoft: '#1D275F',
  textHeading: '#0B1547',
  textHeadingAlt: '#0E1B4D',
  textStrong: '#000A3D',
  textBody: '#4B5565',
  textSecondary: '#5B6579',
  textMuted: '#6B7280',
  textMeta: '#697386',
  textPlaceholder: '#98A2B3',
  textDark: '#101828',
  textInk: '#111827',
  textDisabled: '#A9AFBB',
  primary: '#0F5BFF',
  primaryStrong: '#1A50DD',
  primaryAccent: '#0156fc',
  primaryHover: '#0B4FDF',
  success: '#22C55E',
  textSuccess: '#16A34A',
  textSuccessStrong: '#17A34A',
  error: '#EF4444',
  accentOrange: '#EA6A12',
  badgeOrange: '#db5614',
  warningBg: '#FFFBEB',
  warningBorder: '#FDE68A',
  warningAccent: '#D97706',
  border: '#D1D5DB',
  borderMuted: '#D0D5DD',
  borderSubtle: '#D8DEE8',
  borderSoft: '#E4E7EC',
  borderLight: '#E7EBF2',
  borderLighter: '#E9EDF5',
  borderHover: '#9CA3AF',
  primaryBorderSoft: '#0156fc4d',
  primaryBorderDashed: '#A8C5FF',
  progressTrack: '#ECEFF4',
  progressTrackSoft: '#EEF1F6',
  primaryBgSoft: '#EEF4FF',
  primaryBgSoftHover: '#E2ECFF',
  primaryBgMuted: '#EFF4FF',
  primaryBgSelected: '#F2F7FF',
  primaryBgLight: '#EEF2FF',
  neutralBgSoft: '#F3F4F6',
  panelBgSoft: '#F7F8FA',
  panelBgOverlay: '#f0f1f54d',
  successBgSoft: '#ECFDF3',
  zapBg: '#FFF1E8',
  shieldBg: '#EAF0FF',
  surfaceHover: '#F8FAFC',
  infoText: '#4A587C',
  ring: '#0F5BFF',
  lightInfoBg: '#eef2ff80',
  lightInfoBorder: '#D9E4FF',
  progressTopBorder: 'rgba(223, 228, 236, 0.8)',
  successFocusRing: 'rgba(34, 197, 94, 0.2)',
  primaryFocusRingSoft: 'rgba(1, 86, 252, 0.2)',
  choiceBorder: '#E2E4E9',
  popoverShadow: '0 12px 24px rgba(16, 24, 40, 0.10)',
  radiusMd: '8px',
  contentMaxWidth: 672,
  questionMaxWidth: 512,
  sectionUpcomingText: '#B7BDC8',
  sectionUpcomingBg: '#F3F4F7',
};

export const StepperWrapper = styled(Box)(() => ({
  backgroundColor: ONLINE_CART_TOKENS.surface,
  borderBottom: `1px solid ${ONLINE_CART_TOKENS.borderLighter}`,
}));

export const StepperInner = styled(Box)(({ theme }) => ({
  maxWidth: '1280px',
  margin: '0 auto',
  padding: '14px 20px 16px',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '10px',
  [theme.breakpoints.up('md')]: {
    padding: '12px 28px 14px',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '20px',
  },
}));

export const SectionStepCard = styled(Box)(({ theme, status }) => {
  const isCompleted = status === 'completed';
  const isActive = status === 'active';
  const textColor = isCompleted ? ONLINE_CART_TOKENS.textSuccessStrong : isActive ? ONLINE_CART_TOKENS.primaryStrong : ONLINE_CART_TOKENS.sectionUpcomingText;
  const lineColor = isCompleted ? ONLINE_CART_TOKENS.success : isActive ? ONLINE_CART_TOKENS.primaryStrong : ONLINE_CART_TOKENS.progressTrack;

  return {
    minWidth: 0,
    '& .section-row': {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '8px',
    },
    '& .section-pill': {
      width: '22px',
      height: '22px',
      borderRadius: '999px',
      display: 'grid',
      placeItems: 'center',
      fontSize: '12px',
      fontWeight: 700,
      color: isCompleted || isActive ? ONLINE_CART_TOKENS.surface : ONLINE_CART_TOKENS.textDisabled,
      backgroundColor: isCompleted ? ONLINE_CART_TOKENS.success : isActive ? ONLINE_CART_TOKENS.primaryStrong : ONLINE_CART_TOKENS.sectionUpcomingBg,
      flexShrink: 0,
    },
    '& .section-label': {
      fontSize: '14px',
      lineHeight: 1.3,
      fontWeight: 700,
      color: textColor,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .progress-track': {
      width: '100%',
      height: '4px',
      borderRadius: '999px',
      backgroundColor: ONLINE_CART_TOKENS.progressTrackSoft,
      overflow: 'hidden',
    },
    '& .progress-value': {
      height: '100%',
      borderRadius: '999px',
      backgroundColor: lineColor,
      transition: 'width 240ms ease',
    },
    [theme.breakpoints.down('md')]: {
      '& .section-label': {
        whiteSpace: 'normal',
      },
    },
  };
});
